"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareAltiumPinReferences = compareAltiumPinReferences;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
function compareAltiumPinReferences(left, right) {
    const leftIsNumeric = /^\d+$/.test(left);
    const rightIsNumeric = /^\d+$/.test(right);
    if (leftIsNumeric !== rightIsNumeric) {
        return leftIsNumeric ? -1 : 1;
    }
    return sigma_engine_shared_1.Utils.naturalStringSort(left, right);
}
//# sourceMappingURL=compareAltiumPinReferences.js.map